/* Leucadia® site pages — shared behaviour for The Cellar, The Collection, the category pages,
 * the product page, Tradition and the cart page (2026-10-01 handoff).
 *
 * Every feature is opt-in through data attributes inside a section root ([data-ls-root]):
 *   [data-ls-menu]          phone menu panel, opened by [data-ls-menu-open][aria-controls]
 *   [data-ls-cart-count]    cart badge (LeucadiaCart.count())
 *   .rv                     scroll reveal (fade + 24px rise, 70ms stagger, as in the comps)
 *   [data-ls-gallery]       thumbnail gallery (crossfade, 200ms swap)
 *   [data-ls-qty]           quantity stepper (1–24) → data-leu-qty on [data-ls-qty-target]
 *   [data-ls-atc]           "ADDED ✓" feedback on Add to cart buttons
 *   [data-ls-case]          case-of-3 / case-of-6 toggle with live prices
 *   [data-ls-product]       variant picker for the product page
 *   [data-ls-grid]          category filters (chips) and price sort
 *
 * Adding to the cart and checking out are done by assets/leucadia-cart.js (window.LeucadiaCart)
 * through its own [data-leu-atc] / [data-leu-buy-now] click hooks; this file only keeps those
 * buttons' attributes (variant, quantity) current and gives the shopper feedback.
 */
(function (w, d) {
  'use strict';
  if (w.LeucadiaSite) return;

  var MAX_QTY = 24;
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function on(el, type, fn, opts) { if (el) el.addEventListener(type, fn, opts || false); }
  function reduceMotion() { return !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function money(cents) {
    var n = Math.round(Number(cents || 0)) / 100;
    var whole = Math.round(n) === n;
    return '$' + (whole ? n.toLocaleString('en-US') : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }
  function chlKnows(variantId, handle) {
    var chl = w.LEUCADIA_CHL;
    if (!chl) return false;
    try {
      if (variantId && typeof chl.lookupVariant === 'function' && chl.lookupVariant(variantId)) return true;
      if (handle && typeof chl.lookup === 'function' && chl.lookup(handle)) return true;
    } catch (e) {}
    return false;
  }

  /* ───── Phone menu (the homepage's full-screen menu) ───── */
  function initMenu(root) {
    each(root.querySelectorAll('[data-ls-menu]'), function (panel) {
      var closeBtn = panel.querySelector('[data-ls-menu-close]');
      var openers = d.querySelectorAll('[data-ls-menu-open][aria-controls="' + panel.id + '"]');
      var opener = null;
      function isOpen() { return !panel.hidden; }
      function setMenu(open, from) {
        if (open === isOpen()) return;
        if (open) {
          opener = from || null;
          panel.hidden = false;
          panel.scrollTop = 0;
          if (closeBtn) {
            closeBtn.classList.remove('is-x');
            closeBtn.getBoundingClientRect();
            closeBtn.classList.add('is-x');
            try { closeBtn.focus({ preventScroll: true }); } catch (e) {}
          }
        } else {
          var back = opener, hadFocus = panel.contains(d.activeElement);
          opener = null;
          panel.hidden = true;
          if (closeBtn) closeBtn.classList.remove('is-x');
          if (back && hadFocus) { try { back.focus({ preventScroll: true }); } catch (e) {} }
        }
        d.documentElement.classList.toggle('lh-menu-open', open);
        each(openers, function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      }
      function close() { setMenu(false); }
      each(openers, function (b) { on(b, 'click', function () { setMenu(true, b); }); });
      on(closeBtn, 'click', close);
      each(panel.querySelectorAll('a'), function (a) { on(a, 'click', close); });
      on(d, 'keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
      on(panel, 'keydown', function (e) {
        if (e.key !== 'Tab' || !isOpen()) return;
        var items = [closeBtn].concat(Array.prototype.slice.call(panel.querySelectorAll('a')));
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      if (w.matchMedia) {
        var wide = w.matchMedia('(min-width: 750px)');
        var onWide = function (e) { if (e.matches) close(); };
        if (wide.addEventListener) wide.addEventListener('change', onWide);
      }
      /* Leaving by the browser's back/forward cache must not keep the page locked. */
      on(w, 'pagehide', close);
    });
  }

  /* ───── Cart badge ───── */
  function updateCounts() {
    var cart = w.LeucadiaCart;
    if (!cart || typeof cart.count !== 'function') return;
    var n = cart.count();
    each(d.querySelectorAll('[data-ls-cart-count]'), function (el) { el.textContent = n; el.hidden = !n; });
    each(d.querySelectorAll('[data-ls-cart-count-text]'), function (el) { el.textContent = n; });
  }

  /* ───── Scroll reveal: the comps' .rv → .on, (index % 6) × 70ms stagger ───── */
  var io = null, pending = [];
  function show(el) {
    el.classList.add('on');
    var i = pending.indexOf(el);
    if (i > -1) pending.splice(i, 1);
    if (io) io.unobserve(el);
  }
  function reveal(scope) {
    var all = d.querySelectorAll('.ls .rv');
    if (reduceMotion() || !('IntersectionObserver' in w)) { each(all, function (el) { el.classList.add('on'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) show(e.target); });
      }, { threshold: 0.1 });
    }
    each(all, function (el, i) {
      if (scope && !scope.contains(el)) return;
      if (el.classList.contains('on')) return;
      el.style.transitionDelay = (i % 6) * 0.07 + 's';
      if (pending.indexOf(el) < 0) pending.push(el);
      io.observe(el);
    });
  }
  /* The last rows of a page can sit below the observer's reach on tall screens; once the
     bottom of the page is reached, show whatever is on screen. */
  function revealAtBottom() {
    if (!pending.length) return;
    var de = d.scrollingElement || d.documentElement, vh = w.innerHeight || 800;
    if (de.scrollTop + vh < de.scrollHeight - 2) return;
    pending.slice().forEach(function (el) { if (el.getBoundingClientRect().top < vh) show(el); });
  }

  /* ───── Thumbnail gallery ───── */
  function initGallery(root) {
    each(root.querySelectorAll('[data-ls-gallery]'), function (g) {
      var main = g.querySelector('[data-ls-gallery-main]');
      if (!main) return;
      var thumbs = g.querySelectorAll('[data-ls-thumb]');
      function select(t) {
        each(thumbs, function (x) { x.classList.toggle('on', x === t); x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        if (main.getAttribute('data-current') === t.getAttribute('data-full')) return;
        main.setAttribute('data-current', t.getAttribute('data-full'));
        main.style.opacity = 0;
        setTimeout(function () {
          main.removeAttribute('srcset');
          if (t.getAttribute('data-srcset')) main.setAttribute('srcset', t.getAttribute('data-srcset'));
          main.src = t.getAttribute('data-full');
          main.alt = t.getAttribute('data-alt') || main.alt;
          main.style.opacity = 1;
        }, 200);
      }
      each(thumbs, function (t) { on(t, 'click', function () { select(t); }); });
      g.lsSelect = function (mediaId) {
        each(thumbs, function (t) { if (t.getAttribute('data-media-id') === String(mediaId)) select(t); });
      };
    });
  }

  /* ───── Quantity stepper ───── */
  function initQty(root) {
    each(root.querySelectorAll('[data-ls-qty]'), function (q) {
      var scope = q.closest('[data-ls-buy-scope]') || root;
      var out = q.querySelector('[data-ls-qty-value]');
      var n = 1;
      function set(v) {
        n = Math.max(1, Math.min(MAX_QTY, v));
        if (out) out.textContent = n;
        each(scope.querySelectorAll('[data-ls-qty-target]'), function (b) { b.setAttribute('data-leu-qty', String(n)); });
      }
      on(q.querySelector('[data-ls-qty-dn]'), 'click', function () { set(n - 1); });
      on(q.querySelector('[data-ls-qty-up]'), 'click', function () { set(n + 1); });
      set(1);
    });
  }

  /* ───── Add to cart feedback ─────
     LeucadiaCart adds the line (document click hook on [data-leu-atc]); this swaps the label to
     "ADDED ✓" and shows the scope's "Added to your cart" note, as the comps do. */
  function initAtc(root) {
    each(root.querySelectorAll('[data-ls-atc]'), function (b) {
      var label = b.getAttribute('data-ls-label') || b.textContent;
      var timer = 0;
      on(b, 'click', function () {
        if (b.disabled || b.classList.contains('is-disabled')) return;
        if (!w.LeucadiaCart || !chlKnows(b.getAttribute('data-leu-variant-id'), b.getAttribute('data-leu-handle'))) return;
        var scope = b.closest('[data-ls-buy-scope]') || root;
        b.textContent = b.getAttribute('data-ls-added') || 'ADDED ✓';
        each(scope.querySelectorAll('[data-ls-added-note]'), function (n) { n.hidden = false; });
        clearTimeout(timer);
        timer = setTimeout(function () { b.textContent = label; }, Number(b.getAttribute('data-ls-added-ms') || 1800));
      });
    });
  }

  /* Buttons whose item the Coast Highway catalog can't check out are disabled rather than
     left to fail silently. */
  function checkBuyable(scope) {
    each(scope.querySelectorAll('[data-leu-atc], [data-leu-buy-now]'), function (b) {
      if (b.hasAttribute('data-ls-sold')) return;
      var ok = chlKnows(b.getAttribute('data-leu-variant-id'), b.getAttribute('data-leu-handle'));
      b.classList.toggle('is-disabled', !ok);
      if (b.tagName === 'BUTTON') b.disabled = !ok;
      if (!ok) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
  }

  /* ───── Case of 3 / case of 6 (The Cellar) ───── */
  function initCases(root) {
    each(root.querySelectorAll('[data-ls-case]'), function (card) {
      var prc = card.querySelector('[data-ls-case-price]');
      var ppb = card.querySelector('[data-ls-case-per]');
      var sv = card.querySelector('[data-ls-case-save]');
      var atc = card.querySelector('[data-ls-case-atc]');
      var opts = card.querySelectorAll('[data-ls-case-opt]');
      var base = null; /* the case-of-3 price, for the case-of-6 saving */
      each(opts, function (o) { if (o.getAttribute('data-n') === '3') base = Number(o.getAttribute('data-price')); });
      function pick(o) {
        each(opts, function (x) { x.classList.toggle('on', x === o); x.setAttribute('aria-pressed', x === o ? 'true' : 'false'); });
        var n = Number(o.getAttribute('data-n')) || 1, p = Number(o.getAttribute('data-price'));
        if (prc) prc.textContent = money(p);
        if (ppb) ppb.textContent = money(Math.round(p / n / 100) * 100) + ' / bottle';
        var save = base != null && n === 6 ? base * 2 - p : 0;
        if (sv) { sv.hidden = !(save > 0); sv.textContent = 'SAVE ' + money(save); }
        if (atc) {
          atc.setAttribute('data-leu-variant-id', o.getAttribute('data-variant-id'));
          var sold = o.getAttribute('data-available') === 'false';
          atc.toggleAttribute('data-ls-sold', sold);
          atc.disabled = sold;
          atc.textContent = sold ? 'SOLD OUT' : (atc.getAttribute('data-ls-label') || 'ADD TO CART');
          if (!sold) checkBuyable(card);
        }
      }
      each(opts, function (o) { on(o, 'click', function () { pick(o); }); });
      var first = card.querySelector('[data-ls-case-opt].on') || opts[0];
      if (first) pick(first);
    });
  }

  /* ───── Product page variant picker ───── */
  function initProduct(root) {
    each(root.querySelectorAll('[data-ls-product]'), function (form) {
      var data;
      try { data = JSON.parse((form.querySelector('[data-ls-variants]') || {}).textContent || '[]'); } catch (e) { data = []; }
      if (!data.length) return;
      var groups = form.querySelectorAll('[data-ls-opt-group]');
      var selected = [];
      each(groups, function (g, i) {
        var on1 = g.querySelector('[data-ls-opt].on') || g.querySelector('[data-ls-opt]');
        selected[i] = on1 ? on1.getAttribute('data-value') : null;
      });
      var buttons = form.querySelectorAll('[data-ls-variant-target]');
      var price = form.querySelector('[data-ls-price]');
      var was = form.querySelector('[data-ls-was]');
      var save = form.querySelector('[data-ls-save]');
      var gallery = d.querySelector('[data-ls-gallery]');
      function current() {
        for (var i = 0; i < data.length; i++) {
          var v = data[i], ok = true;
          for (var j = 0; j < selected.length; j++) if (v.options[j] !== selected[j]) { ok = false; break; }
          if (ok) return v;
        }
        return null;
      }
      function apply(fromClick) {
        var v = current();
        each(groups, function (g, i) {
          each(g.querySelectorAll('[data-ls-opt]'), function (b) {
            var isOn = b.getAttribute('data-value') === selected[i];
            b.classList.toggle('on', isOn);
            b.setAttribute('aria-pressed', isOn ? 'true' : 'false');
            /* Mark values that can't be bought with the other choices as they stand. */
            var probe = selected.slice(); probe[i] = b.getAttribute('data-value');
            var match = data.filter(function (x) { return x.options.every(function (o, k) { return o === probe[k]; }); })[0];
            b.classList.toggle('is-out', !match || !match.available);
          });
        });
        each(buttons, function (b) {
          var sold = !v || !v.available;
          if (v) b.setAttribute('data-leu-variant-id', String(v.id));
          b.toggleAttribute('data-ls-sold', sold);
          b.classList.toggle('is-disabled', sold);
          if (b.tagName === 'BUTTON') b.disabled = sold;
          var label = b.getAttribute('data-ls-label') || '';
          b.textContent = sold ? (v ? 'SOLD OUT' : 'UNAVAILABLE') : label;
        });
        if (v) {
          if (price) price.textContent = money(v.price);
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          if (was) { was.hidden = !onSale; if (onSale) was.textContent = money(v.compare_at_price); }
          if (save) { save.hidden = !onSale; if (onSale) save.textContent = 'SAVE ' + money(v.compare_at_price - v.price); }
          if (fromClick && v.featured_media_id && gallery && gallery.lsSelect) gallery.lsSelect(v.featured_media_id);
          if (fromClick && w.history && w.history.replaceState) {
            try { var u = new URL(w.location.href); u.searchParams.set('variant', v.id); w.history.replaceState(null, '', u.toString()); } catch (e) {}
          }
          checkBuyable(form);
        }
      }
      each(groups, function (g, i) {
        each(g.querySelectorAll('[data-ls-opt]'), function (b) {
          on(b, 'click', function () { selected[i] = b.getAttribute('data-value'); apply(true); });
        });
      });
      apply(false);
    });
  }

  /* ───── Category grid: filter chips + price sort (the comps' LXCategory) ───── */
  function initGrid(root) {
    each(root.querySelectorAll('[data-ls-grid]'), function (wrap) {
      var grid = wrap.querySelector('[data-ls-grid-items]');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.children);
      var chips = wrap.querySelectorAll('[data-ls-chip]');
      var sort = wrap.querySelector('[data-ls-sort]');
      var count = wrap.querySelector('[data-ls-count]');
      var type = 'all', order = 'f';
      function draw() {
        var list = cards.filter(function (c) {
          if (type === 'all') return true;
          return (' ' + (c.getAttribute('data-types') || '') + ' ').indexOf(' ' + type + ' ') > -1;
        });
        if (order !== 'f') list = list.slice().sort(function (a, b) {
          var pa = Number(a.getAttribute('data-price')), pb = Number(b.getAttribute('data-price'));
          return order === 'lo' ? pa - pb : pb - pa;
        });
        else list = list.slice().sort(function (a, b) { return Number(a.getAttribute('data-index')) - Number(b.getAttribute('data-index')); });
        cards.forEach(function (c) { c.hidden = list.indexOf(c) < 0; c.classList.remove('on'); });
        list.forEach(function (c) { grid.appendChild(c); });
        if (count) count.textContent = list.length + (list.length === 1 ? ' PRODUCT' : ' PRODUCTS');
        reveal(grid);
      }
      each(chips, function (b) {
        on(b, 'click', function () {
          each(chips, function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          type = b.getAttribute('data-ls-chip');
          draw();
        });
      });
      on(sort, 'change', function () { order = sort.value; draw(); });
      draw();
    });
  }

  function init(root) {
    if (!root || root.hasAttribute('data-ls-ready')) return;
    root.setAttribute('data-ls-ready', '');
    /* assets/leucadia-dawn-integration.js rewrites any "BUY"/"SHOP" link it can tie to a
       bottle; this is its opt-out, so these designs stay as they are. */
    each(root.querySelectorAll('a, button'), function (el) { el.setAttribute('data-leu-buy-hijacked', '1'); });
    each(root.querySelectorAll('a[href$="/cart"]'), function (el) { el.setAttribute('data-leu-hijacked', '1'); });
    initMenu(root);
    initGallery(root);
    initQty(root);
    initCases(root);
    initProduct(root);
    initGrid(root);
    checkBuyable(root);
    initAtc(root);
    each(root.querySelectorAll('video[data-ls-autoplay]'), function (v) {
      v.muted = true;
      if (reduceMotion()) { v.removeAttribute('autoplay'); try { v.pause(); } catch (e) {} return; }
      var p = v.play && v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function boot() {
    each(d.querySelectorAll('[data-ls-root]'), init);
    reveal();
    updateCounts();
  }

  w.LeucadiaSite = { init: init, reveal: reveal, money: money, chlKnows: chlKnows, updateCounts: updateCounts };

  on(d, 'leucadia:cart:change', updateCounts);
  on(w, 'load', updateCounts);
  on(w, 'scroll', revealAtBottom, { passive: true });
  on(d, 'shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ls-root]');
    if (root) { init(root); reveal(root); updateCounts(); }
  });
  if (d.readyState === 'loading') on(d, 'DOMContentLoaded', boot); else boot();
})(window, document);
